import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkMemo from "../../components/molecules/TkMemo";
import { fakeTableList, headList } from "./parts";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import { TkRadioGroup } from "../../components/atoms/TkRadioGroup";
import TkLabelText from "../../components/atoms/TkLabelText";
import { TkGetCode, TkGetCodeList } from "../../utils/TkGetCode";
import {
  CommonOrCommonRetirementFlug,
  CorpTypeList2,
  FormClassApply,
  Prefectures,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { httpAPI_APP016, httpAPI_CON009 } from "./api/request";
import { IAPI_APP016_Request } from "../../type/apiType";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import {
  changeZipcodeFormat,
  isStatusAfterAwaitingReceipt,
} from "../../utils/useTools";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import _ from "lodash";

/**
 * SCRW040001 契約者基本情報　更新
 * @return SCRW040001 契約者基本情報　更新
 */
const SCRW040001 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const [statusList, setStatusList] = useState<any>([]);
  const [infoList, setInfoList] = useState<any>([]);
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState } = useContext(BusinessContext);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  // 申請ID
  const applyId = location.state?.applyId;
  // メモ
  const [memo, setMemo] = useState("");
  // 申請等状態定義の状態id
  const [statusCd, setStatusCd] = useState<any>();
  // 照会画面への反映コードチェック状態
  const [isApplyCodeChecked, setIsApplyCodeChecked] = useState<boolean>(false);
  //承認のflug:true表示、false非表示
  const [isSubmitOpen, setIsSubmitOpen] = useState(false);
  const httpReqIApplicationStatusUpdateRequest: any = {};
  const businessType = businessState.common?.businessType;
  const [defultData, setDefultData] = useState<any>();
  const contractorNoData =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
      ? businessState.common?.contractorNo
      : state.authInfo?.contractorNo;
  // 法人申請区分
  const [corpApplyKbn, setCorpApplyKbn] = useState<"1" | "other" | undefined>();
  const handleInit = async () => {
    let resArr = stateFakeTableList.current;

    // 契約者氏名等変更届・共済契約証書再交付申出参照API 呼び出し
    try {
      const res = await httpAPI_CON009({
        contractorNo: contractorNoData,
        applyId,
      });
      // 初期表示
      if (res.resultCd === "I0000") {
        let str = res.symbolNo?.substring(0, 2);
        let styleData;
        if (str === "共共") {
          styleData = "1";
        } else {
          styleData = "0";
        }
        if (res.symbolNo) {
          const start = res.symbolNo!.lastIndexOf("第") + 1;
          const last = res.symbolNo!.lastIndexOf("号");
          const num = res.symbolNo?.substring(start, last);
          applyId
            ? setDefultData({
                symbolNumber: num,
                symbolNumberType: styleData,
                settlementDate: res.decisionDate,
              })
            : setDefultData({});
        }
        // 法人申請区分
        setCorpApplyKbn(res?.corpApplyKbn as "1" | "other" | undefined);
        // 最新申請状態
        setStatusCd(res.latestApplyStatus);
        // 契約者名称の変更年月日
        resArr.find((item) => item.keyword === "changeDate")!.setDefaultValue =
          res.nameChangeDate;

        // （新）経営者種別
        resArr.find((item) => item.keyword === "newType")!.setDefaultValue =
          res.aBusinessOwnerClass;
        //（旧）経営者種別
        resArr.find((item) => item.keyword === "oldType")!.text = TkGetCode(
          CorpTypeList2,
          res.bBusinessOwnerClass
        );
        // （新）契約者名称（ｶﾅ）
        resArr.find((item) => item.keyword === "newNameKana")!.setDefaultValue =
          res.aCorpNameKana;
        // （旧）契約者名称（ｶﾅ）
        resArr.find((item) => item.keyword === "oldNameKana")!.text =
          res.bCorpNameKana;
        // （新）契約者名称
        resArr.find((item) => item.keyword === "newName")!.setDefaultValue =
          res.aCorpName;
        // （旧）契約者名称
        resArr.find((item) => item.keyword === "oldName")!.text = res.bCorpName;

        // 代表者職名
        resArr.find(
          (item) => item.keyword === "directorTitle"
        )!.setDefaultValue = res.directorTitle;
        // 代表者氏名
        resArr.find(
          (item) => item.keyword === "directorName"
        )!.setDefaultValue = res.directorName;
        // 履歴事項全部証明書（写）
        res.formList?.forEach((item) => {
          if (item.formClass === "1") {
            let historyCertificate = resArr.find(
              (item) => item.keyword === "historyCertificate"
            )!;
            historyCertificate.base64filedata = item.fileBase64;
            historyCertificate.dataname = item.fileName;
          }
        });
        // 主たる事務所の所在地の変更年月日
        resArr.find(
          (item) => item.keyword === "locationChangeDate"
        )!.setDefaultValue = res.addressChangeDate;
        // （新）郵便番号
        resArr.find((item) => item.keyword === "zipcode")!.setDefaultValue =
          res.aZipcode;
        // （新）主たる事務所の所在地
        let resObj = {
          prefectures: TkGetCode(Prefectures, res.aPrefectureName),
          city: res.aCity!,
          address: res.aAddressOthers!,
        };
        resArr.find((item) => item.keyword === "newPrefectures")!.valueObject =
          resObj;
        // （旧）主たる事務所の所在地
        resArr.find(
          (item) => item.keyword === "oldLocation"
        )!.text = `${"〒"}${changeZipcodeFormat(res.bZipcode)} ${TkGetCode(
          Prefectures,
          res?.bPrefectureName
        )} ${res?.bCity} ${res?.bAddressOthers}`;

        resArr.find((item) => item.keyword === "againReissue")!.node = (
          <Box>
            <TkRadioGroup
              radioPropsList={TkGetCodeList(YesOrNoFlug)}
              wantToSetValue={res.reissueApplyFlg}
              disabled={true}
            />
            {res.reissueApplyFlg === "1" && (
              <TkLabelText
                wantToSetValue={res.reissueApplyReason}
                disabled={true}
              />
            )}
          </Box>
        );

        // 処理履歴
        const statusList = res?.statusList?.map((memo) => [
          {
            children: memo.managerName,
          },
          {
            children: memo.process,
          },
          {
            children: memo.createDate,
            align: "center",
          },
          {
            children: memo.processComment,
          },
        ]);
        setStatusList(statusList);

        // 帳票名・決裁日・記号番号
        let file = res.formList?.find(
          (item) =>
            item.formClass ===
            FormClassApply["共済契約者氏名等変更届・共済契約証書再交付申請書"]
        );
        const infoList: any = [
          [
            {
              children: (
                <TkDownloadLink
                  dataname={TkGetCode(FormClassApply, file?.formClass)}
                  base64filedata={file?.fileBase64 ?? ""}
                  downloadBase64
                />
              ),
            },
            {
              children: res.decisionDate,
            },
            {
              children: res.symbolNo,
            },
          ],
        ];
        setInfoList(infoList);

        setStateInfoList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (data: IAPI_APP016_Request, num: any, formData?: any) => {
    data.applyEvent = num;
    data.contractorNo = contractorNoData;
    data.reason = memo;
    data.applyId = applyId;
    if (isApplyCodeChecked) {
      data.inquiryCode = "1";
    }
    data.screenId = "SCRW110001";

    if (formData?.symbolNumber !== undefined && num === "3") {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      data.decisionDate = formData.settlementDate;
    }
    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "受理"
        ? "2"
        : btnName === "契約者に差戻し"
        ? "5"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "承認"
        ? "3"
        : btnName === "上長承認"
        ? "6"
        : btnName === "郵送"
        ? "11"
        : btnName === "課長代理確認"
        ? "14"
        : null;
    if (num === "3") {
      setIsSubmitOpen(true);
      return;
    }
    if (num === null) {
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      num
    );

    // 申請状況更新API 呼び出し
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // ダイアログを閉じる
  const handleDialogClose = () => {
    setIsSubmitOpen(false);
  };

  // 申請状態変更（承認）
  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj(
      httpReqIApplicationStatusUpdateRequest,
      "3",
      formData
    );

    // 申請状況更新API 呼び出し
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });
      if (res.resultCd === "I0000") {
        navigate("/SCRW110001");
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // メモ、チェックボックス入力値変更
  const handleChangeData = (data: any) => {
    if (data?.target?.type === "input") {
      setMemo(data?.target?.value);
    } else {
      setIsApplyCodeChecked(data?.target?.type);
    }
  };

  return (
    <Box className="SCRW040001" data-testid="SCRW040001PageForTest">
      <TkKikoStepper
        applicationFlowType={businessType === "JOB-06" ? "TYPE2" : "TYPE3"}
        businessType={businessType}
        applicationStatus={statusCd}
        corporateApplicationClassification={corpApplyKbn}
      />
      <Box className="name">
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo! +
            ":" +
            businessState.common?.contractorName!
          }
        />
      </Box>
      <TkFakeTable list={stateInfoList} ruleSchema={{}} showButton={false} />
      {/* メモ、コメント、チェックボックス */}
      <TkMemo
        bodyList={statusList}
        showTable={true}
        onChange={handleChangeData}
      />

      {isStatusAfterAwaitingReceipt(statusCd) && (
        <TkTableWithNoLine headList={headList} bodyList={infoList} />
      )}

      <Box className="btn">
        <TkBackButton />
        <TkViewButtonJudgement
          flowType={businessType === "JOB-06" ? "TYPE2" : "TYPE3"}
          Status={statusCd}
          onClick={btnEvent}
          data-testid="TkViewButtonJudgement"
        />
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW040001PageForDialog"
        open={isSubmitOpen}
        onSuccess={handleSave}
        onClose={() => {
          handleDialogClose();
        }}
        wantToSetValue={defultData}
      />
    </Box>
  );
};

export default SCRW040001;
